import {
  CardContent as MuiCardContent,
  Card as MuiCard,
  Typography, Box, Fade
} from "@material-ui/core";
import styled from "styled-components/macro";
import TableStats from "./components/TableStats";
import { FC } from "react";
import NoDataAvailable from "./components/NoDataAvailable";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)`
        position: relative;
        border-radius: 14px
    `;
const CardContent = styled(MuiCardContent)`
        position: relative;
        padding: 0;
        height:371px;
        &:last-child {
            padding-bottom: 0
        }
    `;

type PropsType = {
  contractData: any
}

const YourSubscription: FC<PropsType> = ({contractData}) => {
  const { t } = useTranslation()
  const haveData = contractData?.products?.length > 0

  const getTableData = () => {
    if (haveData) {
      // @ts-ignore
      const uniqueProducts = [...new Map(contractData.products.map(
        (item: any) => [item["name"], item])).values()];

      return uniqueProducts.map((product: any) => {
        return {
          name: product.name + ` x${contractData.products
            .filter((i: any) => i.name.includes(product.name)).length}`,
          price: Number(product.price) + ' SEK'
        }
      })
    }
    return []
  }


  return (
    <Fade in={true}>
      <Card>
        <CardContent>
          <Box p={4}>
            <Typography>
              {t('statsPage_Your_subscription')}
            </Typography>
          </Box>
          <Loading loading={!contractData}>
            <Box>
              <TableStats
                rows={getTableData()}
                height={300}
              />
              <NoDataAvailable visible={!haveData}/>
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}
export default YourSubscription
